import {useMutation, useQueryClient} from "@tanstack/react-query";
import {toast} from "react-toastify";
import {create} from "../../../app/setters/create.js";

export const useDodajZdarzenieProcesuHarm = (setErrors, close) => {

    const queryClient = useQueryClient()


    return useMutation({
        mutationFn: (data) => {
            return create(`/oper/plan-harm/proces`, data)
        },
        // onError: () => {
        //     toast.error('Błąd podczas operacji')
        // },
        onSettled: async (data, error, variables) => {

            await queryClient.invalidateQueries({
                queryKey: [`lista_procesow_harm`,variables.rejestr_id],
            })
        },
        onSuccess: async ({message, status, errors}) => {
            await setErrors(errors)
            status === 'success' ? await toast.success(message) : await toast.error(message)
            status === 'success' && close()
        },
    })
}